import styled, { css } from 'styled-components';

export const TableBodyWrapper = styled.div<{ height: number }>`
    ${({ height }) => css`
        height: ${height}px;
    `}
`;

export const TableBodyElement = styled.div``;
